import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ResolveErrorRoutingModule } from './resolve-error-routing.module';
import {ResolveErrorComponent} from './resolve-error.component';
import {TranslateModule} from '@ngx-translate/core';
import {TableModule} from "primeng/table";
import {CoreModule} from "../../core/core.module";
import {DropdownModule} from "primeng/dropdown";
import {CalendarModule} from "primeng/calendar";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {MultiSelectModule} from "primeng/multiselect";
import {AutoCompleteModule} from "primeng/autocomplete";
import {CheckboxModule} from "primeng/checkbox";
import {FormsModule} from "@angular/forms";

@NgModule({
  imports: [
    CommonModule,
    ResolveErrorRoutingModule,
    TranslateModule,
    TableModule,
    CoreModule,
    DropdownModule,
    CalendarModule,
    NgbModule,
    MultiSelectModule,
    AutoCompleteModule,
    CheckboxModule,
    FormsModule
  ],
  exports: [
    ResolveErrorComponent
  ],
  declarations: [ResolveErrorComponent]
})
export class ResolveErrorModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/features/resolve-error/resolve-error.module.ts